module.exports = __webpack_public_path__ + "images/emoji/cactus.4b7210a3aece9b77c29c.png";